import React from 'react';

import { useUFOReportError } from '@atlaskit/react-ufo/report-error';

interface HubErrorLoggerProps {
	error?: Error;
	shouldForceError?: boolean;
}

export const HubErrorLogger = ({ error, shouldForceError }: HubErrorLoggerProps) => {
	const logError = useUFOReportError();

	React.useEffect(() => {
		logError({
			name: error?.name || 'unknown',
			errorMessage: error?.message || '',
			errorStack: error?.stack || '',
			forcedError: shouldForceError,
		});
	}, [logError, error, shouldForceError]);

	return null;
};
